// vendor

import Swiper, {
  Navigation, Pagination, EffectFade, Autoplay,
} from 'swiper/core';

// components

import Validation from '@/js/components/forms/validation';
// import PinnedListWithImages from '@/js/components/animations/pinned_list_with_images';
import Services from './partials/services';
import TitleAnimation from './partials/titleAnimation';
import Reviews from './partials/reviews';
import News from './partials/news';
import Instagram from './partials/instagram';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

class Home {
  constructor() {
    this.dom = {
      formSubscribe: document.querySelector('.js-form-subscribe'),
      services: document.getElementById('services'),
      titlescroll: document.getElementById('title-scroll'),
      reviews: document.getElementById('swiper-reviews'),
      news: document.getElementById('news'),
      swiperInstagram: document.getElementById('swiper-instagram'),
    };

    this.components = {
      subscribeFormValidation: null,
      services: null,
      titlescroll: null,
      reviews: null,
      news: null,
      instagram: null,
    };

    this.data = {};

    this.events = {};

    this.mount();
  }

  mount() {
    // validate subscribe form
    if (this.dom.formSubscribe) {
      this.components.subscribeFormValidation = new Validation(this.dom.formSubscribe);
    }

    // services actions
    if (this.dom.services) {
      // this.components.services = new PinnedListWithImages(this.dom.services);
      setTimeout(() => {
        this.components.services = new Services(this.dom.services);
      }, 100);
    }

    // cases actions
    if (this.dom.titlescroll) {
      this.components.titlescroll = new TitleAnimation(this.dom.titlescroll);
    }

    if (this.dom.reviews) {
      this.components.reviews = new Reviews(this.dom.reviews);
    }

    // news actions
    if (this.dom.news) {
      this.components.news = new News(this.dom.news);
    }

    // init instagram swiper
    if (this.dom.swiperInstagram) {
      setTimeout(() => {
        this.components.instagram = new Instagram(this.dom.swiperInstagram);
      }, 500);
    }
  }
}

if (document.getElementById('page-home')) {
  // eslint-disable-next-line no-new
  new Home();
}
